module.exports = __webpack_public_path__ + "static/media/015-woman-4.e5c02176.svg";